import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { GlobalServiceProvider } from '../providers/global-service/global-service';
import { OneSignal, OSNotificationPayload } from '@ionic-native/onesignal';
import { LoginPage } from '../pages/login/login';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = LoginPage;
  
  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private oneSignal: OneSignal) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();

      if (GlobalServiceProvider.isCordovaAvailable()) {
        this.oneSignal.startInit(GlobalServiceProvider.OneSignalAppID, GlobalServiceProvider.SenderID);
        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
        this.oneSignal.handleNotificationReceived().subscribe(data => this.onPushReceived(data.payload));
        this.oneSignal.handleNotificationOpened().subscribe(data => this.onPushOpened(data.notification.payload));
        this.oneSignal.endInit();
      }

      splashScreen.hide();
    });

  }
  private onPushReceived(payload: OSNotificationPayload) {
    //alert('Push recevied:' + payload.body);
  }

  private onPushOpened(payload: OSNotificationPayload) {
   // alert('Push opened: ' + payload.body);
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts